import React, { useMemo } from 'react';

import { runningInRNWebView, useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { TipsCard } from '@eika/card';

import { useConfig } from '@/default-config';
import useTipsCardCookies from '@/widgets/ApplePayProvisionTipsCard/useTipsCardCookies';

import useText from '@hooks/use-text';

const ApplePayProvisioningTipsCard: React.FC = () => {
    const { links } = useConfig();
    const texts = useText();

    const nativeProps = useReactNativeProps();

    const [show, setCookies] = useTipsCardCookies();

    const enabled = useMemo(
        () =>
            Boolean(nativeProps.supports?.applePay) &&
            Boolean(nativeProps.appleWallet?.hasAvailableCardsForLocalOnboarding) &&
            (nativeProps.appleWallet?.localPasses ?? []).length === 0,
        [
            nativeProps.supports?.applePay,
            nativeProps.appleWallet?.hasAvailableCardsForLocalOnboarding,
            nativeProps.appleWallet?.localPasses,
        ],
    );

    const showTipsCard = show && runningInRNWebView && enabled && nativeProps.supports?.cookies === true;

    if (!showTipsCard) return null;

    return (
        <TipsCard
            label={texts.news}
            title={texts.youCanUseApplePay}
            text={texts.simplerPaymentsFromMobile}
            link={links.cardLandingPage.url}
            onClose={setCookies}
        />
    );
};

export default ApplePayProvisioningTipsCard;
